import React from "react";
import { Checkbox, DatePicker, Tooltip } from "antd";
import Styles from "./ExpertRecordsStyles.module.css";
export default function AdditionalFilter({ state, onChangeFunc }) {
  const maxDate = () => {
    let newDate = new Date();
    return newDate.toISOString().split("T")[0];
  };
  return (
    <div style={{ textAlign: "center", width: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        <span style={{ width: "25%", marginRight: "15px", textAlign: "start" }}>
          <span style={{ fontSize: "14px",color: "#2A364A", fontWeight: "300" }}>
            From Date&nbsp;
          </span>
        </span>
        <span className="py-1">
          <input
            onChange={(e) => onChangeFunc(e.target.value, "from")}
            max={maxDate()}
            value={state.from}
            className={Styles.inputFilterTab}
            type="date"
          />
          &nbsp;&nbsp;
          {state.from !== "" && (
            <Tooltip
              placement="top"
              title={() => (
                <span style={{color: "black", fontSize: "10px" }}>
                  Clear date
                </span>
              )}
              color="#fff"
            >
              <i
                className="fa fa-close"
                style={{ fontSize: "18px", cursor: "pointer" }}
                onClick={() => onChangeFunc("", "from")}
                max={maxDate()}
              ></i>
            </Tooltip>
          )}
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        <span style={{ width: "25%", marginRight: "15px", textAlign: "start" }}>
          <span style={{fontSize: "14px",  color: "#2A364A",fontWeight: "300" }}>
            To Date&nbsp;
          </span>
        </span>
        <span className="py-1">
          <input
            min={state.from}
            max={maxDate()}
            onChange={(e) => onChangeFunc(e.target.value, "to")}
            value={state.to}
            className={Styles.inputFilterTab}
            type="date"
          />
          &nbsp;&nbsp;
          {state.to !== "" && (
            <Tooltip
              placement="top"
              title={() => (
                <span style={{ color: "black", fontSize: "10px" }}>
                  Clear date
                </span>
              )}
              color="#fff"
            >
              <i
                className="fa fa-close"
                style={{ fontSize: "18px", cursor: "pointer" }}
                onClick={() => onChangeFunc("", "to")}
              ></i>
            </Tooltip>
          )}
        </span>
      </div>
    </div>
  );
}
